import { TextField, type TextFieldProps, inputBaseClasses } from "@mui/material";
import { styled } from "@mui/material/styles";

const PREFIX = "EmailField";

export const classes = {
  root: `${PREFIX}-root`,
  chips: `${PREFIX}-chips`,
  moreChips: `${PREFIX}-moreChips`,
};

export const TextFieldStyled = styled(TextField, {
  shouldForwardProp: (prop) => prop !== "focus" && prop !== "limitTags",
})<TextFieldProps & { focus: boolean; limitTags: number }>(({ theme, limitTags, focus }) => ({
  [`&.${classes.root}`]: {
    [`& .${inputBaseClasses.root}`]: {
      paddingTop: "8.5px",
      paddingBottom: "8.5px",
      paddingLeft: theme.spacing(0.75),
      paddingRight: theme.spacing(0.75),
      flexWrap: "wrap",
      columnGap: theme.spacing(0.5),
      rowGap: theme.spacing(1),
      [`& .${classes.chips}`]: {
        marginTop: "-2px",
        marginBottom: "-2px",
        [`&:nth-of-type(1n+${limitTags + 1})`]: {
          ...(!focus && { display: "none" }),
        },
      },
      [`& .${classes.moreChips}`]: {
        marginTop: "-2px",
        marginBottom: "-2px",
        ...(focus && { display: "none" }),
      },
      [`& .${inputBaseClasses.input}`]: {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        width: "unset",
        minWidth: "100px",
        flex: "auto",
      },
    },
  },
}));
